<template>  
    <restore-form/> 
</template>

<script>  
import restoreForm from '@/components/forms/auth/restore';

export default {
    name: 'auth-login',
    components: { 
        restoreForm
    }
}
</script>